// extracted by mini-css-extract-plugin
export var cardIcon = "_19-5";
export var cardIconUnframed = "_19-9";
export var checkboxCard = "_19-0";
export var checkboxCardSelected = "_19-4";
export var disabled = "_19-2";
export var interactive = "_19-1";
export var outerBorder = "_19-3";
export var spacerMedium = "_19-8";
export var spacerSmall = "_19-7";
export var spacerXsmall = "_19-6";